import React, { useState } from "react";
import { graphql, useStaticQuery } from "gatsby";
import { getTrueClasses } from "../../../../helpers";
import FastGatsbyImage from "../../../../containers/common/FastGatsbyImage";
import Delta from "./Delta";
import "./index.scss";

const Screen = () => {
  const [isShowVideo, setIsShowVideo] = useState(false);

  const imageData = useStaticQuery(graphql`
    query {
      default: file(
        sourceInstanceName: { eq: "images" }
        relativeDirectory: { eq: "components/HomeIntro" }
        name: { eq: "home-video" }
        ext: { eq: ".png" }
      ) {
        ...ImageData
      }
      midDesk: file(
        sourceInstanceName: { eq: "images" }
        relativeDirectory: { eq: "components/HomeIntro" }
        name: { eq: "home-video@midDesk" }
        ext: { eq: ".png" }
      ) {
        ...ImageData
      }
      smallDesk: file(
        sourceInstanceName: { eq: "images" }
        relativeDirectory: { eq: "components/HomeIntro" }
        name: { eq: "home-video@smallDesk" }
        ext: { eq: ".png" }
      ) {
        ...ImageData
      }
      mid: file(
        sourceInstanceName: { eq: "images" }
        relativeDirectory: { eq: "components/HomeIntro" }
        name: { eq: "home-video@mid" }
        ext: { eq: ".png" }
      ) {
        ...ImageData
      }
      mob: file(
        sourceInstanceName: { eq: "images" }
        relativeDirectory: { eq: "components/HomeIntro" }
        name: { eq: "home-video@mob" }
        ext: { eq: ".png" }
      ) {
        ...ImageData
      }
    }

    fragment ImageData on File {
      childImageSharp {
        gatsbyImageData(
          layout: CONSTRAINED
          placeholder: BLURRED
          formats: [AUTO, WEBP]
        )
      }
    }
  `);
  return (
    <div
      onClick={() => setIsShowVideo(true)}
      className={getTrueClasses(
        "PgESM-HI-S",
        isShowVideo ? "PgESM-HI-S_video" : "PgESM-HI-S_screenPlay"
      )}
    >
      {isShowVideo ? (
        <iframe
          src="https://www.youtube.com/embed/UCUEItN0ONc?autoplay=1&modestbranding=1"
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          title="youtube"
          className="PgESM-HI-S__iframe"
        />
      ) : (
        <>
          <FastGatsbyImage
            imageData={imageData}
            imageClassName="PgESM-HI-S__img"
            isAdaptive
            isFullBreaks
          />
          <div className="PgESM-HI-S-play">
            <Delta />
          </div>
        </>
      )}
    </div>
  );
};

export default Screen;
